import { StateCreator } from 'zustand';
import { IAppState, IHomebaseSlice } from './stateTypes';
import HomePageExperience from '../../pages/home/hero/store/HomePageExperience';
import HomebaseTab from '../../pages/home/hero/store/HomebaseTab';
import { getVehiclesForRecentlyViewedTiles } from '../../pages/home/hero/utils';
import {
    fetchAndBuildTransferStatus,
    TransferStatus,
    hasInProgressTransfer,
} from '../../pages/home/utilities/transferStatusBuilder';
import { IVehicleTile } from '../../types/vehicleTile';

const timeout = (ms: number) =>
    new Promise((_, reject) => setTimeout(() => reject(new Error('request timed out')), ms));

const createHomeBaseSlice: StateCreator<IAppState, [], [], IHomebaseSlice> = (set) => ({
    isLoading: true,
    experience: HomePageExperience.FirstTimeVisitor,
    homeBaseTab: HomebaseTab.RecentlyViewed,
    setHomeBaseTab: (homeBaseTab) => set({ homeBaseTab }),
    loadHomePageExperience: async ({ enableUFTHome }: { enableUFTHome: boolean }) => {
        try {
            const result = await Promise.race([
                Promise.all([getVehiclesForRecentlyViewedTiles(), fetchAndBuildTransferStatus()]),
                timeout(5000),
            ]);

            if (Array.isArray(result) && result.length === 2) {
                const [recentlyViewedVehicles, transfersTile] = result as [IVehicleTile[], TransferStatus];
                let transferStatus: TransferStatus | undefined;
                let experience = HomePageExperience.FirstTimeVisitor;
                if (hasInProgressTransfer(transfersTile)) {
                    experience = HomePageExperience.Transfer;
                    transferStatus = transfersTile;
                } else if (recentlyViewedVehicles.length > 0) {
                    experience = HomePageExperience.ReturnVisitor;
                }

                set({
                    isLoading: false,
                    recentlyViewedVehicles,
                    experience,
                    transferStatus,
                    serveUFTContent: enableUFTHome,
                });

                // Send message to fullStory that tells us that the home page experience has loaded and which experience it is for testing purposes                if(!window.FS)
                // @ts-expect-error Not defining the FullStory function just for this test
                if (window.FS) {
                    // @ts-expect-error Not defining the FullStory function just for this test
                    window.FS('trackEvent', {
                        name: 'PageData',
                        properties: {
                            testName: `uft-home:${enableUFTHome ? 'enabled' : 'disabled'}`,
                            experience: HomePageExperience[experience],
                        },
                    });
                }
            } else {
                // Timeout or unexpected result
                set({ isLoading: false, serveUFTContent: enableUFTHome });
            }
        } catch (error) {
            console.error('Error loading home page experience:', error);
            set({ isLoading: false, serveUFTContent: enableUFTHome });
        }
    },
});

export default createHomeBaseSlice;
